import ApiCore from '../utilities/Core';

// Login API

const url = 'absenceList';
const plural = 'absenceList';
const single = 'absenceList';

export const apiAbsenceList = new ApiCore({
    getAll: false,
    getSingle: false,
    post: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
    plural: plural,
    single: single,
});
